export default __webpack_public_path__ + "static/media/waterlinked-logo.d373ac60.png";